<!--
 * @Author: vince
 * @Date: 2021-08-31 09:55:37
 * @LastEditors: vince
 * @LastEditTime: 2021-09-04 17:36:04
 * @Description: 
-->
<template>
  <el-select
    size="small"
    v-if="controlType == 'select'"
    value-key="schoolYear"
    :multiple="multiple"
    :loading="loading"
    v-model="valueTemp"
    placeholder="请选择学年"
    :clearable="clearable"
    @change="onChange"
    :disabled="disabled"
  >
    <el-option
      v-for="item in options"
      :value="item"
      :key="item.schoolYear"
      :label="item.schoolYear"
    ></el-option>
  </el-select>
  <el-checkbox-group
    v-else-if="controlType == 'checkbox'"
    v-model="checkTemp"
    @change="onChange"
  >
    <el-checkbox v-for="(item, index) in options" :key="index" :label="item">{{
      item.schoolYear
    }}</el-checkbox>
  </el-checkbox-group>
</template>

<script>
import { mapGetters } from "vuex";
import { postData } from "../../http/fetch.js";
export default {
  model: {
    prop: "value",
    event: "change",
  },
  data() {
    return {
      loading: false,
      checkTemp: [],
      valueTemp: null,
      options: [],
    };
  },
  watch: {
    value(v) {
      this.valueTemp = v;
      this.checkTemp = v;
    },
  },
  props: {
    multiple: {
      type: Boolean,
      default: false,
    },
    controlType: {
      type: String,
      default: "select",
    },
    value: {
      type: Object | Array,
    },
    isDefaultValue: {
      type: Boolean,
      default: false,
    },
    clearable: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters(["schoolCode", "schoolList"]),
  },
  created() {
    this.valueTemp = this.value;
    this.getSemesterList();
  },
  methods: {
    onChange(v) {
      this.$emit("change", v);
    },
    getSemesterList() {
      this.loading = true;
      postData("/school/getSemesterList", {
        regionId: this.schoolList[0].provinceId,
        pageSize: -1,
        pageNum: 1,
      })
        .then((res) => {
          if (res.records.length) {
            this.options = Array.from(
              new Set(res.records.map((m) => m.schoolYear))
            );
            if (this.isDefaultValue) {
              this.valueTemp = this.options[0];
              this.$emit("change", this.valueTemp);
            }
          } else {
            this.options = [];
          }
        })
        .catch((e) => {})
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style>
</style>